import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'antd'
import { compose, graphql } from 'react-apollo'
import { inject, observer } from 'mobx-react'
// import { FormattedMessage } from 'react-intl'
import _get from 'lodash/get'
// import moment from 'moment'
// import gql from 'graphql-tag'
import './styles.css'

import Img from './Components/Img'
// import EventName from './Components/EventName'
// import ShortDescription from './Components/ShortDescription'
import EntryFee from './Components/EntryFee'
// import Countdown from './Components/Countdown'
import Description from './Components/Description'
import eventFromSlugQuery from '~/App/graphql/queries/eventFromSlug.gql'
// import Race from './Components/Race'
// import Map from './Components/Map'
// import Remark from './Components/Remark'

// const { Content } = Layout
import { EventPageContent } from '~/styles'
class EventPage extends Component {
  // static propTypes = {
  //   match: PropTypes.shape({
  //     params: PropTypes.shape({
  //       id: PropTypes.string.isRequired,
  //     })
  //   })
  // }
  componentWillMount () {
    // this.props.mutate({variables: {id}})
    // console.log(id)
  }
  render () {
    // const { id } = this.props.match.params
    // console.log(this.props.match.params)
    // const { } = this.props
    // console.log(data, this.props.match)
    // console.log('loading', data.loading, 'event', data.event)
    // if (data && data.event && data.event.name) {
    //   console.log(data.event.races)
    //   return <div>test</div>
    const { event, loading, i18n: { locale } } = this.props
    // console.log({ event })
    // }
    // console.log(event, loading)
    // console.log(event)
    if (loading) {
      return <div>Loading...</div>
    } else if (!event) {
      return <div>Event not found</div>
    } else {
      // const { l: locale = 'th' } = queryString.parse(search)
      // console.log(data.event)
      const contentSections = _get(event, 'contentSections', [])
      // const startDate = _get(event, 'startDate', '')
      return (
        <EventPageContent>
          <div className="eventPage">
            {/* <Img image={event.coverUrl} /> */}
            <Img eventName={event.name} src={event.coverUrl} />
            {/* <EventName eventName={event.name} /> */}
            {/* <div className="short_description">
              <div
                className="container"
                style={{
                  textAlign: 'center',
                  padding: '26px',
                  color: 'white',
                  fontWeight: 'bold',
                  fontSize: '24px',
                  margin: 0
                }}
              >
                Race Day: {moment(startDate).format('dddd D MMMM YYYY, HH:mm')}
              </div>
            </div> */}
            {/* <ShortDescription day={event.startDate} location={event.location} /> */}
            <Row>
              {/* TODO: should pass the whole event? and set up appropriate prop types */}
              <EntryFee
                isRegOpen={event.isRegOpen}
                priceSource={_get(event, 'settings.payment.priceSource')}
                periods={event.periods}
                registrationTypes={event.registrationTypes}
                ticketTypes={event.ticketTypes}
                slug={event.slug}
                dateTime={event.startDate}
                location={event.location}
                liveLegacy={event.liveLegacy}
                website={event.website}
                customMessage={_get(event, 'settings.registration.customMessage')}
              />
              {' '}
              {/* TODO: should pass event object for slug? or register link */}
              <Col md={{ span: 15, pull: 7 }}>
                {/*
                <div className="main_description">
                  <Countdown date={event.startDate} />
                   <Description description={event.description} />
                  <Race race={event.races} />
                  <Map />
                  <Remark />
                </div>
                */}
                <Description
                  description={_get(event, ['description', locale])}
                  dateTime={event.startDate}
                  coverUrl={event.coverUrl}
                />
                <div className="eventContent">
                  {contentSections.map(section => (
                    <section key={section._id}>
                      <h1>{_get(section, ['title', locale])}</h1>
                      <div className="details"
                        dangerouslySetInnerHTML={{
                          __html: _get(section, ['body', locale])
                        }}
                      />
                    </section>
                  ))}
                </div>
              </Col>
            </Row>
          </div>
        </EventPageContent>
      )
    }
  }
}

// EventPage
EventPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      eventSlug: PropTypes.string
    })
  }).isRequired
}

export default compose(
  inject('i18n'),
  graphql(eventFromSlugQuery, {
    options: props => ({
      variables: {
        slug: props.match.params.eventSlug
      }
    }),
    props: ({ data: { loading, eventFromSlug } }) => ({
      loading,
      event: eventFromSlug
    })
  }),
  observer
)(EventPage)



// WEBPACK FOOTER //
// ./src/App/EventPage/EventPage.js